
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compliance/resources/agents-licensing-guide",
      function () {
        return require("private-next-pages/compliance/resources/agents-licensing-guide.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compliance/resources/agents-licensing-guide"])
      });
    }
  